import React from "react";
import styled from "styled-components";
import theme from "../../styles/theme";

// First and Last path is repeated to allow smooth transitions
const SpermTailPaths = [
  "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 \
  19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,\
  41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5",
  "M32.3,22.5 C31.3,24.3 32.3,26.4 30.8,27.8 C29.4,29.3 26.7,29.3 23.7,29.5 C20.6,29.6 \
  19.1,29.4 17.3,31.2 C15.5,33.0 15.8,35.4 15.5,37.7 C15.1,40.1 15.6,43.0 13.7,45.0 C11.7,\
  47.0 10.4,46.2 7.0,46.1 C4.9,46.1 2.6,45.9 0.4,48.1",
  "M32.3,22.5 C30.4,23.5 29.2,24.0 29.0,25.8 C28.8,27.6 28.4,30.3 26.5,32.1 C24.7,34.0 23.0,\
  33.1 19.9,33.3 C16.8,33.4 15.3,33.1 13.3,35.3 C11.5,37.1 11.8,39.9 11.8,43.0 C11.7,46.1 11.9,\
  46.8 9.7,48.9 C8.2,50.4 6.3,50.2 2.7,50.4",
  "M32.3,22.5 C30.1,22.6 26.7,21.8 25.2,23.3 C23.8,24.7 23.9,26.9 23.7,29.5 C23.5,32.0 \
  24.1,34.5 22.3,36.3 C20.5,38.1 18.1,37.7 15.5,37.7 C13.3,37.7 10.6,37.9 8.6,39.9 C6.6,\
  41.9 7.1,43.7 7.0,46.1 C6.9,48.6 8.0,50.7 5.8,52.9",
  "M32.3,22.5 C31.3,24.3 29.6,24.9 27.9,25.2 C25.9,25.6 23.3,25.2 21.3,27.2 C19.4,29.1 \
  19.4,31.1 19.5,33.7 C19.6,36.1 19.7,38.9 18.0,40.7 C16.0,42.6 13.6,42.2 11.1,42.0 C8.8,\
  41.8 6.6,41.8 4.7,43.8 C3.4,45.2 3.4,46.4 2.7,50.5"
];

export default ({ animated = true, color = "white" }) => {
  const animation = (
    <animate
      dur="0.6s"
      repeatCount="indefinite"
      attributeName="d"
      values={SpermTailPaths.join(";")}
    />
  );

  const SpermTail = (
    <path
      d={SpermTailPaths[0]}
      stroke={theme.colors[color]}
      strokeWidth="3"
      strokeLinecap="round"
    >
      {animated && animation}
    </path>
  );

  const SpermHead = (
    <ellipse
      fill={theme.colors[color]}
      transform="translate(40.501453, 14.237608) rotate(45) translate(-40.501453, -14.237608) "
      cx="40.501453"
      cy="14.2376084"
      rx="8"
      ry="11.8646142"
    />
  );

  return (
    <div className="sperm">
      <svg
        width="80px"
        height="25px"
        viewBox="0 0 80 25"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* translations straighten out the head and tail */}
        <g fill="none" transform="translate(37, -30) rotate(45)">
          {SpermHead}
          {SpermTail}
        </g>
      </svg>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/atoms/Sperm.js